<template>
	<div class="container">
		<Header />
		<div class="content">
			<div class="table">
				<div class="title">员工列表</div>
				<div class="table_content">
					<el-table :data="tableData" border class="staff_table">
						<el-table-column prop="id" label="序号" width="80"></el-table-column>
						<el-table-column prop="name" label="姓名" width="120"></el-table-column>
						<el-table-column prop="phone" label="联系手机号" width="130"></el-table-column>
						<el-table-column prop="unitName" label="所属单位"></el-table-column>
						<el-table-column prop="position" label="岗位" width="140"></el-table-column>
						<el-table-column prop="createDate" label="入职日期" width="130"></el-table-column>
						<el-table-column prop="status" label="状态" width="120">
							<template slot-scope="scope">
								<span :class="scope.row.status === 1 ? 'text_success' : 'text_disable'">
								  {{ scope.row.status === 1 ? "在职" : "离职" }}
								</span>
							</template>
						</el-table-column>
						<el-table-column label="操作" width="130">
							<template slot-scope="scope">
								<el-button v-if="false" type="text" @click="openEdit(scope.row)">编辑</el-button>
								<el-button type="text" @click="openView(scope.row)">查看</el-button>
							</template>
						</el-table-column>
					</el-table>
				</div>
			</div>
		</div>
		<el-dialog
			title="员工信息"
			:visible="dialogVisible"
			width="620px"
			top="26vh"
			@close="closeDialog"
		>
			<el-form :model="formData" label-width="120px">
				<el-form-item label="姓名">
					<el-input v-model="formData.name"></el-input>
				</el-form-item>
				<el-form-item label="联系手机号">
					<el-input v-model="formData.phone"></el-input>
				</el-form-item>
				<el-form-item label="所属合作单位">
					<el-input v-model="formData.unitName"></el-input>
				</el-form-item>
				<el-form-item label="岗位">
					<el-input v-model="formData.position"></el-input>
				</el-form-item>
				<el-form-item label="入职日期">
					<el-date-picker v-model="formData.createDate" type="date"></el-date-picker>
				</el-form-item>
				<el-form-item label="状态">
					<el-radio-group v-model="formData.status">
						<el-radio :label="1">在职</el-radio>
						<el-radio :label="0">离职</el-radio>
					</el-radio-group>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="closeDialog">取消</el-button>
				<el-button type="primary" @click="saveForm">保存</el-button>
			</div>
		</el-dialog>
		<Footer />
	</div>
</template>

<script>
	import Header from "../../components/common/Header";
	import Footer from "../../components/common/Footer";
	import api from "../../axios/interface";
	export default {
		name: "StaffManage",
		data() {
			return {
				dialogVisible: false,
				tableData: [],
				formData: {
					id: null,
					name: "",
					phone: "",
					unitName: "",
					position: "",
					createDate: "",
					status: 1
				}
			};
		},
		components: {
			Header,
			Footer
		},
		mounted() {
			this.getList();
		},
		methods: {
			getList() {
				// this.$axios.get(api.StaffList, {}, { hideMessage: true }).then(res => {
				//   this.tableData = res.result.data;
				// })
				this.tableData = [
					{
						id: 1,
						name: "李玲",
						phone: "138****5344",
						unitName: "总部",
						position: "档案管理员",
						createDate: "2023-11-05",
						status: 1
					},
					{
						id: 2,
						name: "王超杰",
						phone: "177****1189",
						unitName: "总部",
						position: "信息专员",
						createDate: "2021-06-13",
						status: 1
					},
				];
			},
			openEdit(row) {
				this.formData = { ...row };
				this.dialogVisible = true;
			},
			openView(row) {
				this.formData = { ...row };
				this.dialogVisible = true;
			},
			saveForm() {
				this.dialogVisible = false;
				this.getList();
			},
			closeDialog() {
				this.dialogVisible = false;
			}
		}
	};
</script>

<style lang="less" scoped>
	.container {
		width: 100%;
		height: 100vh;
		overflow: hidden;
	}
	.content {
		width: 1056px;
		margin: 90px 50px 0 50px;
		height: auto;
		text-align: center;
		padding-bottom: 30px;
		border-radius: 10px;
		background: #fff;
		display: flex;
		flex-direction: column;
	}
	.content .table {
		width: 960px;
		height: auto;
		margin: 0 48px;
		.title {
			height: 45px;
			line-height: 45px;
			text-align: center;
			font-size: 32px;
			color: #4d4d4d;
			margin-top: 70px;
			margin-bottom: 30px;
		}
		.table_content {
			border-radius: 5px;
		}
	}
	.staff_table {
		thead {
			tr > th {
				.cell {
					color: #333333;
					font-weight: 500;
				}
			}
		}
		td,
		th.is-leaf {
			border-bottom: 1px solid #eeeeee;
		}
	}
	.text_success {
		color: #0079fe;
	}
	.text_disable {
		color: #999;
	}
	.dialog-footer {
		text-align: right;
	}
</style>
